import React, { Component } from 'react';

import BuisnessMap from './BuisnessMap';
import Currency from './Currency';
import ForeignTrade from './ForeignTrade';
import GosUslugy from './GosUslugy';
import MGZ from './MGZ';
import ParticipantCategory from './ParticipantCategory';
import ProductStructure from './ProductStructure';

import { CaseMainTitle } from '../../components/newDesign/CaseMainTitle';
import { MainWrapper } from '../../components/newDesign/MainWrapper/MainWrapper';
import { RadioGroup } from '../../components/newDesign/RadioGroup';
import Foodbasket from '../../pages/Social/FoodBasket';
import { logCaseVisit } from '../../services/api';

const NAME_COMP = {
  'Мониторинг государственных закупок': <MGZ />,
  'Курсы валют': <Currency />,
  'Внешняя торговля': <ForeignTrade />,
  'Товарная структура': <ProductStructure />,
  'Категория участников ВЭД': <ParticipantCategory />,
  'Мониторинг социальных цен на продукты питания': <Foodbasket />,
  'Карта бизнеса': <BuisnessMap />,
  'Государственные услуги': <GosUslugy />,
};

const CASE_NAME_BY_SUBTAB = {
  'Мониторинг государственных закупок': 'MONITORING_GOV_PROCUREMENT',
};

class Economic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      radio: Object.keys(NAME_COMP)[0],
    };
    this.lastLoggedCaseName = null;
  }

  componentDidMount() {
    this.logCaseVisitForCurrentRadio();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.radio !== this.state.radio || prevProps.subtabs !== this.props.subtabs) {
      this.logCaseVisitForCurrentRadio();
    }
  }

  logCaseVisitForCurrentRadio = () => {
    const { subtabs } = this.props;
    const { radio } = this.state;

    const currentSubtab = Array.isArray(subtabs)
      ? subtabs.find((subtab) => subtab.name === radio)
      : null;

    const fromBackend = currentSubtab && currentSubtab.caseName;
    const fromLocalMap = CASE_NAME_BY_SUBTAB[radio];

    const caseName = fromBackend || fromLocalMap;

    if (caseName && caseName !== this.lastLoggedCaseName) {
      this.lastLoggedCaseName = caseName;
      logCaseVisit(caseName).catch(() => {});
    }
  };

  radioChange = (value) => {
    this.setState({
      radio: value.target.value,
    });
  };

  render() {
    const { subtabs } = this.props;
    return (
      <MainWrapper>
        <CaseMainTitle>Экономика</CaseMainTitle>

        <RadioGroup
          onChange={this.radioChange}
          value={this.state.radio}
          list={subtabs.map((i) => ({
            key: i.name,
            value: i.name,
          }))}
        />

        {Object.keys(NAME_COMP).map((nav) => {
          if (nav === this.state.radio) return NAME_COMP[nav];
          else return null;
        })}
      </MainWrapper>
    );
  }
}

export default Economic;
